import { ShieldCheck, Lock } from "lucide-react";

const Card = ({ children, label }) => (
  <span
    role="img"
    aria-label={label}
    data-testid={`pay-logo-${label.toLowerCase()}`}
    className="inline-flex h-7 w-11 items-center justify-center rounded-md border border-slate-200 bg-white shadow-sm"
  >
    {children}
  </span>
);

const Visa = () => (
  <Card label="Visa">
    <svg viewBox="0 0 48 16" className="h-3.5 w-auto">
      <text x="0" y="13" fontFamily="Arial, sans-serif" fontSize="15" fontWeight="700" fontStyle="italic" fill="#1A1F71">VISA</text>
    </svg>
  </Card>
);

const Mastercard = () => (
  <Card label="Mastercard">
    <svg viewBox="0 0 40 24" className="h-4 w-auto">
      <circle cx="16" cy="12" r="9" fill="#EB001B" />
      <circle cx="24" cy="12" r="9" fill="#F79E1B" />
      <path d="M20 5.2a9 9 0 0 0 0 13.6 9 9 0 0 0 0-13.6Z" fill="#FF5F00" />
    </svg>
  </Card>
);

const Amex = () => (
  <Card label="Amex">
    <svg viewBox="0 0 44 24" className="h-5 w-auto">
      <rect width="44" height="24" rx="3" fill="#1F72CF" />
      <text x="22" y="15" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="8" fontWeight="800" fill="#fff" letterSpacing="0.5">AMEX</text>
    </svg>
  </Card>
);

const Discover = () => (
  <Card label="Discover">
    <svg viewBox="0 0 48 16" className="h-3 w-auto overflow-visible">
      <text x="0" y="12" fontFamily="Arial, sans-serif" fontSize="9" fontWeight="800" fill="#1a1a1a">DISC</text>
      <circle cx="42" cy="8" r="6" fill="#F58220" />
    </svg>
  </Card>
);

const PayPal = () => (
  <Card label="PayPal">
    <svg viewBox="0 0 56 16" className="h-3.5 w-auto">
      <text x="0" y="13" fontFamily="Arial, sans-serif" fontSize="13" fontWeight="800" fontStyle="italic" fill="#003087">Pay</text>
      <text x="25" y="13" fontFamily="Arial, sans-serif" fontSize="13" fontWeight="800" fontStyle="italic" fill="#009CDE">Pal</text>
    </svg>
  </Card>
);

const LOGOS = [Visa, Mastercard, Amex, Discover, PayPal];

export const SecureCheckout = ({ variant = "default", className = "" }) => {
  const footer = variant === "footer";
  return (
    <div
      data-testid={`secure-checkout-${variant}`}
      className={`flex flex-col ${footer ? "items-start" : "items-center"} gap-2.5 ${className}`}
    >
      <span className={`inline-flex items-center gap-1.5 text-xs font-semibold ${footer ? "text-slate-500" : "text-slate-600"}`}>
        {footer ? <Lock className="h-3.5 w-3.5 text-emerald-600" /> : <ShieldCheck className="h-4 w-4 text-emerald-600" />}
        Secure checkout · SSL encrypted
      </span>
      <div className="flex flex-wrap items-center gap-1.5">
        {LOGOS.map((Logo, i) => (
          <Logo key={i} />
        ))}
      </div>
    </div>
  );
};
